module.exports = __webpack_public_path__ + "c1c60987d8eaf7795e0ff0ac6cec1d68.png";